import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { BarChart3 } from 'lucide-react';

interface ResultsHeaderProps {
  rank: number;
  totalPoints: number;
  onLeaderboardClick: () => void;
}

export const ResultsHeader: React.FC<ResultsHeaderProps> = ({
  rank,
  totalPoints,
  onLeaderboardClick,
}) => {
  const { t } = useTranslation();

  return (
    <div data-test-id="results-header" className="flex items-center gap-3 px-4 py-3">
      <div
        data-test-id="rank-display"
        className="bg-white/10 rounded h-[38px] px-3 flex flex-col items-center justify-center min-w-[64px]"
      >
        <div className="text-white text-base font-bold leading-4">{rank}</div>
        <div className="text-white text-xs font-bold">{t('game.results.rank')}</div>
      </div>

      <div
        data-test-id="points-display"
        className="bg-white/10 rounded h-[38px] px-3 flex flex-col items-center justify-center min-w-[64px]"
      >
        <div className="text-white text-base font-bold leading-4">{totalPoints}</div>
        <div className="text-white text-xs font-bold">{t('game.results.totalPts')}</div>
      </div>

      <Button
        data-test-id="leaderboard-btn"
        variant="bet99"
        onClick={onLeaderboardClick}
        className="flex-1 h-[38px] gap-2 text-sm font-bold px-4 py-0"
      >
        <BarChart3 className="w-4 h-4" />
        {t('game.actions.leaderboard')}
      </Button>
    </div>
  );
};
